import * as ko from "knockout";
import entityBase from "entityBase";

export class address extends entityBase {
  address_id: KnockoutObservable<number>;
  address: KnockoutObservable<string>;
  name: KnockoutObservable<string>;
  full_address: KnockoutObservable<string>;
  second_address: KnockoutObservable<string>;
  third_address: KnockoutObservable<string>;
  zippost: KnockoutObservable<string>;
  country: KnockoutObservable<string>;
  city: KnockoutObservable<string>;
  state_prov: KnockoutObservable<string>;
  phone: KnockoutObservable<string>;
  user_def2: KnockoutObservable<string>;
  user_def3: KnockoutObservable<string>;

  constructor(item?: any) {
    super();
    this.address_id = ko.observable(item?.address_id);
    this.address = ko.observable(item?.address).extend({ maxLength: 64 });
    this.name = ko.observable(item?.name);
    this.full_address = ko.observable(item?.full_address).extend({ maxLength: 512 });
    this.second_address = ko.observable(item?.second_address).extend({ maxLength: 64 });
    this.third_address = ko.observable(item?.third_address).extend({ maxLength: 255 });
    this.zippost = ko.observable(item?.zippost).extend({ maxLength: 64 });
    this.country = ko.observable(item?.country).extend({ maxLength: 32 });
    this.city = ko.observable(item?.city).extend({ maxLength: 64 });
    this.state_prov = ko.observable(item?.state_prov).extend({ maxLength: 255 });
    this.phone = ko.observable(item?.phone).extend({ maxLength: 32 });
    this.user_def2 = ko.observable(item?.user_def2).extend({ maxLength: 64 });
    this.user_def3 = ko.observable(item?.user_def3).extend({ maxLength: 64 });
  }
}
